export default __webpack_public_path__ + "static/media/royWhite.e6dd158c.svg";